/* Token icon URLs.
 * Strategy:
 *   TW    → Trust Wallet assets via raw.githubusercontent.com (most reliable for major EVM tokens)
 *   CMC   → CoinMarketCap CDN by token id, wrapped in wsrv.nl proxy to bypass occasional
 *           hot-link / referer restrictions and to guarantee 128px square delivery.
 *   SOL   → solana-labs/token-list raw github (for SPL tokens)
 *   PROXY → wsrv.nl image proxy (last resort for vendor CDNs)
 */
const TW_ETH = (addr) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/${addr}/logo.png`;
const TW_BSC = (addr) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/smartchain/assets/${addr}/logo.png`;
const TW_SOL = (mint) =>
  `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/solana/assets/${mint}/logo.png`;
const CMC    = (id) =>
  `https://s2.coinmarketcap.com/static/img/coins/128x128/${id}.png`;
const SOL_LIST = (mint) =>
  `https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/${mint}/logo.png`;
const PROXY = (url) =>
  `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=128&h=128&output=png`;

export const TOKEN_ICONS = {
  // ============== EVM ==============
  ETH:    CMC(1027),
  BNB:    CMC(1839),
  MATIC:  CMC(3890),
  LINK:   CMC(1975),
  UNI:    CMC(7083),
  AAVE:   CMC(7278),
  CRV:    CMC(6538),
  LDO:    CMC(8000),
  MKR:    CMC(1518),
  SNX:    CMC(2586),
  COMP:   CMC(5692),
  SUSHI:  CMC(6758),
  "1INCH":CMC(8104),
  GRT:    CMC(6719),
  ARB:    CMC(11841),
  OP:     CMC(11840),
  RPL:    TW_ETH("0xD33526068D116cE69F19A9ee46F0bd304F21A51f"),
  FXS:    CMC(6953),
  PENDLE: CMC(9481),
  GMX:    CMC(11857),
  DYDX:   TW_ETH("0x92D6C1e31e14520e676a687F0a93788B716BEff5"),
  ENS:    CMC(13855),
  BAL:    CMC(5728),
  YFI:    CMC(5864),
  CVX:    CMC(9903),
  FRAX:   CMC(6952),
  APE:    TW_ETH("0x4d224452801ACEd8B2F0aebE155379bb5D594381"),
  SHIB:   TW_ETH("0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE"),
  PEPE:   CMC(24478),
  WBTC:   CMC(3717),
  AVAX:   CMC(5805),
  FTM:    CMC(3513),
  INJ:    CMC(7226),
  LRC:    CMC(1934),
  IMX:    CMC(10603),
  MANA:   CMC(1966),
  SAND:   CMC(6210),
  AXS:    TW_ETH("0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b"),
  CAKE:   TW_BSC("0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82"),
  FET:    CMC(3773),
  BLUR:   CMC(23121),
  WLD:    CMC(13502),
  MNT:    CMC(27075),
  METIS:  CMC(9640),
  CHZ:    TW_ETH("0x3506424F91fD33084466F402d5D97f05F8e3b4AF"),
  BAT:    TW_ETH("0x0D8775F648430679A709E98d2b0Cb6250d2887EF"),
  ZRX:    TW_ETH("0xE41d2489571d322189246DaFA5ebDe1F4699F498"),
  ENJ:    TW_ETH("0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c"),
  GALA:   TW_ETH("0xd1d2Eb1B1e90B638588728b4130137D262C87cae"),
  ANKR:   TW_ETH("0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4"),
  AGIX:   TW_ETH("0x5B7533812759B45C2B44C19e320ba2cD2681b542"),
  BAND:   TW_ETH("0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55"),
  OCEAN:  TW_ETH("0x967da4048cD07aB37855c090aAF366e4ce1b9F48"),
  NMR:    TW_ETH("0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671"),
  RSR:    TW_ETH("0x320623b8E4fF03373931769A31Fc52A4E78B5d70"),
  LPT:    TW_ETH("0x58b6A8A3302369DAEc383334672404Ee733aB239"),
  ARKM:   TW_ETH("0x6E2a43be0B1d33b726f0CA3b8de60b3482b8b050"),
  HOT:    TW_ETH("0x6c6EE5e31d828De241282B9606C8e98Ea48526E2"),
  SUPER:  TW_ETH("0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55"),
  TON:    CMC(11419),

  // ============== Solana ==============
  SOL:    CMC(5426),
  JUP:    CMC(29210),
  JTO:    CMC(28541),
  BONK:   CMC(23095),
  WIF:    CMC(28752),
  PYTH:   CMC(28177),
  RAY:    CMC(8526),
  ORCA:   CMC(11165),
  MNGO:   CMC(11171),
  RNDR:   CMC(5690),
  STEP:   SOL_LIST("StepAscQoEioFxxWGnh2sLBDFp9d8rvKz2Yp39iDpyT"),
  FIDA:   CMC(7978),
  SAMO:   CMC(8086),
  KIN:    CMC(1993),
  MSOL:   SOL_LIST("mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So"),
  BSOL:   SOL_LIST("bSo13r4TkiE4KumL71LsHTPpL2euBYLFx6h9HP3piy1"),
  JITOSOL:PROXY("https://storage.googleapis.com/token-metadata/JitoSOL-256.png"),
  POPCAT: CMC(28782),
  HNT:    CMC(5665),
  DRIFT:  CMC(32487),
  WEN:    CMC(29175),
  MEW:    CMC(30126),
  BOME:   CMC(29870),
  MYRO:   CMC(28382),
  PNUT:   CMC(33139),
  GOAT:   CMC(33440),
  JLP:    PROXY("https://static.jup.ag/jlp/icon.png"),
  NEON:   TW_SOL("NeonTjSjsuo3rexg9o6vHuMXw62f9V7zvmu8M8Zut44"),
  MOODENG:CMC(33093),
  MOTHER: CMC(30843),
  W:        CMC(33108),
  TNSR:     CMC(30450),
  KMNO:     CMC(30924),
  IO:       CMC(32237),
  ZEUS:     CMC(31394),
  CLOUD:    CMC(32604),
  PRCL:     CMC(30013),
  MNDE:     CMC(11787),
  ATLAS:    CMC(11212),
  POLIS:    CMC(12119),
  SHDW:     SOL_LIST("SHDWyBxihqiCj6YekG2GUr7wqKLeLAMK1gHZck9pL6y"),
  SLERF:    CMC(29920),
  GIGA:     CMC(32417),
  CHILLGUY: CMC(33545),
  FWOG:     CMC(33523),
  MICHI:    CMC(32494),
  AI16Z:    CMC(33910),
  TRUMP:    CMC(35336),
  ALEPH:    CMC(4351),
  MOCA:     CMC(31188),
};

export function getIcon(symbol) {
  return TOKEN_ICONS[symbol] || null;
}
